export const isLiftsUrlWhiteListed = (liftsUrl?: string | null) => (liftsUrl || '').indexOf('passemontagne.fr') >= 0;

export default isLiftsUrlWhiteListed;
